import React from 'react';
import { Typography, Box, List, ListItem, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Alert } from '@mui/material';
import LegalLayout from './LegalLayout';

const DeliveryInfo: React.FC = () => {
  const deliveryZones = [
    {
      zone: 'София (в града)',
      time: '1-2 работни дни',
      cost: 'цената зависи от тарифата на куриерската фирма',
      freeShipping: 'Безплатно над 150 €'
    },
    {
      zone: 'Пловдив, Варна, Бургас',
      time: '2-3 работни дни',
      cost: 'цената зависи от тарифата на куриерската фирма',
      freeShipping: 'Безплатно над 150 €'
    },
    {
      zone: 'Други градове',
      time: '3-5 работни дни',
      cost: 'цената зависи от тарифата на куриерската фирма',
      freeShipping: 'Безплатно над 150 €'
    },
    {
      zone: 'Села и отдалечени места',
      time: '3-7 работни дни',
      cost: 'цената зависи от тарифата на куриерската фирма',
      freeShipping: 'Безплатно над 150 €'
    }
  ];

  return (
    <LegalLayout title="Информация за доставка">
      <Alert severity="info" sx={{ mb: 3 }}>
        Предлагаме бърза и сигурна доставка до цялата страна чрез водещи куриерски компании.
      </Alert>

      <Typography variant="h5" component="h2" gutterBottom>
        1. Срокове за доставка
      </Typography>
      <Typography paragraph>
        Стандартната доставка се извършва в рамките на 3 работни дни от потвърждаване 
        на поръчката. Срокът може да варира в зависимост от локацията и наличността 
        на продуктите.
      </Typography>

      <TableContainer component={Paper} sx={{ mt: 2, mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Зона</strong></TableCell>
              <TableCell><strong>Срок</strong></TableCell>
              <TableCell><strong>Цена</strong></TableCell>
              <TableCell><strong>Безплатна доставка</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveryZones.map((zone, index) => (
              <TableRow key={index}>
                <TableCell>{zone.zone}</TableCell>
                <TableCell>{zone.time}</TableCell>
                <TableCell>{zone.cost}</TableCell>
                <TableCell>{zone.freeShipping}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        2. Куриерски фирми
      </Typography>
      <Typography paragraph>
        Работим с проверени и надеждни куриерски компании:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Еконт (Econt)" 
            secondary="Най-голямата куриерска мрежа в България с офиси в цялата страна" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Спиди (Speedy)" 
            secondary="Бърза доставка до офис или до адрес" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        3. Видове доставка
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
        До офис на куриера:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="По-ниска цена" 
            secondary="Спестявате около 0,50-1 € от доставката до адрес"
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Гъвкавост" 
            secondary="Вземате пратката когато Ви е удобно в работното време на офиса" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Сигурност" 
            secondary="Пратката се съхранява до 10 дни в офиса" 
          />
        </ListItem>
      </List>

      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
        До адрес:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Удобство" 
            secondary="Получавате пратката директно на посочения адрес" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Обаждане" 
            secondary="Куриерът се обажда преди доставката" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Гъвкави часове" 
            secondary="Възможност за уговаряне на удобно време" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        4. Международна доставка
      </Typography>
      <Typography paragraph>
        Предлагаме международна доставка до страните от Европейския съюз и други държави:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="ЕС страни" 
            secondary="5-10 работни дни"
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Други страни" 
            secondary="По договаряне, срок 10-20 работни дни" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Митнически такси" 
            secondary="За сметка на получателя (ако има)" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        5. Проследяване на пратка
      </Typography>
      <Typography paragraph>
        След изпращане на поръчката ще получите:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Имейл потвърждение"
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Статус в профила" 
            secondary="Можете да проследявате статуса на поръчката в потребителския си профил" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        6. Условия за доставка
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
        Обработка на поръчката:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Работни дни" 
            secondary="Поръчки до 14:00 ч. се обработват същия ден" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Извън работно време" 
            secondary="Поръчки се обработват следващия работен ден" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Уикенди и празници" 
            secondary="Не се обработват поръчки" 
          />
        </ListItem>
      </List>

      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
        Получаване на пратката:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Документ за самоличност" 
            secondary="Необходим при получаване на пратката" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Проверка" 
            secondary="Можете да проверите продуктите преди плащане (при наложен платеж)" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Отказ от приемане" 
            secondary="Можете да откажете пратката, ако има видими повреди" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        7. Специални условия
      </Typography>
      
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography variant="body2">
          При лошо време или извънредни обстоятелства доставките могат да бъдат забавени.
        </Typography>
      </Alert>

      <List>
        <ListItem>
          <ListItemText 
            primary="Голям обем" 
            secondary="Продукти над 30 кг могат да изискват специална доставка" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Крехки продукти" 
            secondary="Специална опаковка и маркировка за деликатни артикули" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Експресна доставка" 
            secondary="Възможна при спешност срещу допълнителна такса" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        8. Контакт за доставки
      </Typography>
      <Typography paragraph>
        За въпроси относно доставката:
      </Typography>
      <Typography paragraph>
        <strong>Отдел "Логистика"</strong><br />
        Имейл: delivery@goldenbooks.bg<br />
        Телефон: 0895628293<br />
        Работно време: 9:00 - 18:00 ч. (понеделник - петък)
      </Typography>

      <Alert severity="success" sx={{ mt: 3 }}>
        Безплатна доставка за поръчки над 150 € в цялата страна!
        Поръчайте днес и получете книгите си бързо и сигурно.
      </Alert>
    </LegalLayout>
  );
};

export default DeliveryInfo;